<template>
    <BaseList
        search-placeholder="Search by organization name..."
        :filtered-count="filteredContacts.length"
        :total-count="contacts.length"
        :current-page="currentPage"
        :items-per-page-prop="itemsPerPage"
        @search="handleSearch"
        @page-change="changePage"
        @items-per-page-change="handleItemsPerPageChange"
    >
        <table id="contactslist">
            <thead>
                <tr>
                    <th>Organization</th>
                    <th>Organization Type</th>
                    <th>Author</th>
                    <th>Projects</th>
                    <th>Created</th>
                    <th>Modified</th>
                    <th>Notes</th>
                </tr>
            </thead>
            <tbody v-if="dataLoaded" >
                <tr v-for="contact in paginatedContacts" :key="contact.id">
                    <td><router-link :to="('/customers/'+contact.id)">{{contact.name |  truncate(40)}}</router-link></td>
                    <td>{{contact.orgType  | capitalize | truncate(40)}}
                    <td><router-link :to="('/users/'+contact.authorId)"> {{contact.authorName | truncate(40)}} </router-link></td>
                    <td>{{contact.projects}}</td>
                    <td>{{contact.created | date}}</td>
                    <td>{{contact.modified | date}}</td>
                    <td class="notes">{{contact.notes | truncate(150)}}</td>
                </tr>
            </tbody>
        </table>
    </BaseList>
</template>

<script>
    // Import Helpers
    import {CallApi} from '../Utilities.js'
    import BaseList from './BaseList.vue'

    export default {
        name: 'OrganizationList',
        components: {
            BaseList
        },
        watch: {
            '$route': 'fetchData'
        },
        data: function () {
            return {
                dataLoaded: false,
                contacts: [],
                filteredContacts: [],
                currentPage: 1,
                itemsPerPage: 50
            }
        },
        computed: {
            paginatedContacts: function() {
                const start = (this.currentPage - 1) * this.itemsPerPage;
                const end = start + this.itemsPerPage;
                return this.filteredContacts.slice(start, end);
            }
        },
        methods: {
            fuzzyMatch: function(searchText, targetText) {
                const search = searchText.toLowerCase().trim();
                const target = targetText.toLowerCase();

                if (!search) return true;

                const searchTerms = search.split(/\s+/).map(term => {
                    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    return `(?:^|[^a-z0-9])${escaped}`;
                });

                const pattern = searchTerms.map(term => `(?=.*${term})`).join('');
                const regex = new RegExp(pattern);

                return regex.test(target);
            },
            handleSearch: function(searchText) {
                if (!searchText) {
                    this.filteredContacts = this.contacts;
                } else {
                    this.filteredContacts = this.contacts.filter(contact => {
                        return this.fuzzyMatch(searchText, contact.name || '');
                    });
                }
                this.currentPage = 1;
            },
            changePage: function(newPage) {
                this.currentPage = newPage;
            },
            handleItemsPerPageChange: function(newValue) {
                this.itemsPerPage = newValue;
                this.currentPage = 1;
            },
            fetchData: async function() {
                this.contacts = (await CallApi('GET', '/organizations')).contacts
                this.filteredContacts = this.contacts;
                this.dataLoaded = true
            },
        },
        mounted() {
            this.fetchData();
        }
    }
</script>
